<template>
  <div>
    <div class="d-inline-block w-50 mt-1">
      <title-breadcrumb :page="page" :has-route="true"></title-breadcrumb>
    </div>
    <router-view />
  </div>
</template>

<script>
import store, { name } from '@/modules/users/store'
import TitleBreadcrumb from '@/components/common/page/TitleBreadcrumb'

export default {
  name: 'UsersWrapper',
  components: { TitleBreadcrumb },
  data: () => ({
    page: {
      title: 'Usuarios',
      icon: 'fas fa-shield-alt',
      routes: ['Usuarios'],
    },
  }),
  provide() {
    return {
      page: this.page,
    }
  },
  created() {
    if (!this.$store.state[name]) {
      this.$store.registerModule(name, store)
    }
  },
  destroyed() {
    if (this.$store.state[name]) {
      this.$store.unregisterModule(name)
    }
  },
}
</script>
